import { useEffect, useState } from 'react';
import { setCookie, getCookie } from './helpers';
export const useEducationalMessage = ({ uniqueHideCookieName, isPlatformJourneyEnabled, }) => {
    const isHideCookieUndefined = getCookie(uniqueHideCookieName) === undefined;
    const [isVisible, setIsVisible] = useState(isHideCookieUndefined);
    useEffect(() => {
        setIsVisible(isHideCookieUndefined && isPlatformJourneyEnabled);
    }, [isHideCookieUndefined, isPlatformJourneyEnabled]);
    const hideEducationalMessage = () => {
        setCookie(uniqueHideCookieName, '', null, '/');
        setIsVisible(false);
    };
    return {
        isVisible,
        hideEducationalMessage,
    };
};
//# sourceMappingURL=useEducationalMessage.js.map